export const createSystemMessageSiteCoreKeys = {
  headerKey:
    "PermissionAndMessages.SystemMessages.CreateSystemMessagePopupHeaderAndFooter",
  editSystemMessagesHeader:
    "SystemMessages.CreateSystemMessagePopupHeaderAndFooter.EditSystemMessagesHeader",
  publishButton:
    "SystemMessages.CreateSystemMessagePopupHeaderAndFooter.PublishButton",
  viewSystemMessagesHeader:
    "SystemMessages.CreateSystemMessagePopupHeaderAndFooter.ViewSystemMessagesHeader",
  createMessageKey:
    "PermissionAndMessages.SystemMessages.CreateSystemMessagePopup",
  countryAndLanguage:
    "SystemMessages.CreateSystemMessagePopup.CountryAndLanguage",
  fromDateTime: "CreateSystemMessagePopup.Duration.FromDateTime",
  durationSection: "SystemMessages.CreateSystemMessagePopup.DurationSection",
  timeZone: "CreateSystemMessagePopup.Duration.TimeZone",
  toDateTime: "CreateSystemMessagePopup.Duration.ToDateTime",
  message: "CreateSystemMessagePopup.MessageDetails.Message",
  messageDetailsSection:
    "SystemMessages.CreateSystemMessagePopup.MessageDetailsSection",
  selectPreferences:
    "CreateSystemMessagePopup.MessageDetails.SelectPreferences",
  title: "CreateSystemMessagePopup.MessageDetails.Title",
  addLinkToThisMessageCheckBox:
    "MessageDetails.SelectPreferences.AddLinkToThisMessageCheckBox",
  keepTheMessagePersistentCheckBox:
    "MessageDetails.SelectPreferences.KeepTheMessagePersistentCheckBox",
  systemMessageDeleteConfirmation:
    "SystemMessages.CreateSystemMessagePopup.SystemMessageDeleteConfirmation",
  systemMessageDeletedMessage:
    "SystemMessages.CreateSystemMessagePopup.SystemMessageDeletedMessage",
  systemMessagePublishedMessage:
    "SystemMessages.CreateSystemMessagePopup.SystemMessagePublishedMessage",
  systemMessageUpdateConfirmation:
    "SystemMessages.CreateSystemMessagePopup.SystemMessageUpdateConfirmation",
  systemMessageUpdatedMessage:
    "SystemMessages.CreateSystemMessagePopup.SystemMessageUpdatedMessage",
  selectedCountryAndLanguage:
    "SystemMessages.CreateSystemMessagePopup.SelectedCountryAndLanguage",
  linkName: "CreateSystemMessagePopup.MessageDetails.LinkName",
  linkPosition: "CreateSystemMessagePopup.MessageDetails.LinkPosition",
  linkURL: "CreateSystemMessagePopup.MessageDetails.LinkURL",
  linkPositionList: "CreateSystemMessagePopup.MessageDetails.LinkPositionList",
  messageId: "SystemMessages.CreateSystemMessagePopup.MessageID",
  country: "SystemMessages.CreateSystemMessagePopup.Country",
  language: "SystemMessages.CreateSystemMessagePopup.Language",
  belowTheMessage: "LinkPosition.BelowTheMessage",
  toDateTimeFromDateValidationMessage:
    "CreateSystemMessagePopup.Duration.ToDateTimeFromDateValidationMessage",
  invalidLinkURL: "CreateSystemMessagePopup.MessageDetails.InvalidLinkURL",
  selectedPreferences:
    "CreateSystemMessagePopup.MessageDetails.SelectedPreferences",
  linkAdded: "CreateSystemMessagePopup.MessageDetails.LinkAdded",
  persistentMessage:
    "CreateSystemMessagePopup.MessageDetails.PersistentMessage",
  enterValidFromDateTime:
    "CreateSystemMessagePopup.Duration.EnterValidFromDateTime",
};
